// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__BrSGe","logo":"LinkedLogo_logo__-ZpeB","skeleton":"LinkedLogo_skeleton__Vk0zf","skeletonSlide":"LinkedLogo_skeletonSlide__7jGeO"};